export default [{
  id: 1,
  description: 'Lease',
  other: 'dmm',
}, {
  id: 2,
  description: 'Purchase',
  other: 'dmm',
}];
